import React from "react";
import eyeImg from "./assets/images/inclusive-eye.svg";

export default function footer({ isOpenInclusive, setIsOpenInclusive }) {
  return (
    <footer className="sg-app-footer">
      <div className="sg-app-upper-footer">
        <ul className="top-nav__list" id="sg_footer_button_list">
          <li className="top-nav__list-item">
            <a
              className="link"
              aria-label="Як отримати"
              href="https://sgroshi.com.ua/ua/credit/"
            >
              Як отримати
            </a>
          </li>
          <li className="top-nav__list-item">
            <a
              className="link"
              aria-label="Питання та відповіді"
              href="https://sgroshi.com.ua/ua/faq/"
            >
              Питання та відповіді
            </a>
          </li>
          <li className="top-nav__list-item">
            <a
              className="link"
              aria-label="Блог"
              href="https://sgroshi.com.ua/ua/blog/"
            >
              Блог
            </a>
          </li>
          <li className="top-nav__list-item">
            <a
              className="link"
              aria-label="Новини"
              href="https://sgroshi.com.ua/ua/news/"
            >
              Новини
            </a>
          </li>
          <li className="top-nav__list-item">
            <a
              className="link"
              aria-label="Контакти"
              href="https://sgroshi.com.ua/ua/contacts/"
            >
              Контакти
            </a>
          </li>
          <li className="top-nav__list-item">
            <a
              className="link"
              aria-label="Про компанію"
              href="https://sgroshi.com.ua/ua/about/"
            >
              Про компанію
            </a>
          </li>
          <li className="top-nav__list-item">
            <a
              className="link"
              aria-label="Особистий кабінет"
              href="https://sgroshi.com.ua/ua/kabinet/"
            >
              Особистий кабінет
            </a>
          </li>
          <li className="top-nav__list-item">
            <a
              className="link"
              aria-label="Вакансії"
              href="https://sgroshi.com.ua/ua/work/"
            >
              Вакансії
            </a>
          </li>
          <li className="top-nav__list-item">
            <a
              className="link"
              aria-label="Карта сайту"
              href="https://sgroshi.com.ua/ua/sitemap/"
            >
              Карта сайту
            </a>
          </li>
          <li className="top-nav__list-item">
            <a
              className="link"
              aria-label="Оплатити"
              href="https://sgroshi.com.ua/ua/oplatyty-kredyt/"
            >
              Оплатити
            </a>
          </li>
          <li className="top-nav__list-item">
            <a
              className="link"
              aria-label="Безбар'єрність"
              href="https://sgroshi.com.ua/ua/inclusive/"
            >
              Безбар'єрність
            </a>
          </li>
          <li className="top-nav__list-item">
            <a
              className="link"
              aria-label="Партнерам"
              href="https://sgroshi.com.ua/ua/affiliate/"
            >
              Партнерам
            </a>
          </li>
          <li className="top-nav__list-item">
            <a
              className="link"
              aria-label="Зворотній зв'язок"
              href="https://sgroshi.com.ua/ua/reverse-form/"
            >
              Зворотній зв'язок
            </a>
          </li>
          <li className="top-nav__list-item">
            <a
              className="link"
              aria-label="Написати скаргу"
              href="https://sgroshi.com.ua/ua/reverse-form/"
            >
              Написати скаргу
            </a>
          </li>
        </ul>
        <div className="inclusive-row">
          <div className="top-nav__list-item">
            <a
              target="_blank"
              className="link"
              aria-label="Написати скаргу"
              href="/inclusive/Viddilennia_z_bezbariiernym_dostupom.pdf"
            >
              Перелік безбар`єрних підрозділів
            </a>
          </div>
        </div>
        <div className="inclusive-row">
          <button
            className="inclusive-row-link"
            id="web_eye_togler_footer"
            aria-label="Налаштування доступності"
            onClick={() => setIsOpenInclusive(!isOpenInclusive)}
          >
            <img
              data-not-hide-image="true"
              src={eyeImg}
              alt="inclusive-eye-icon"
            />
            <span>Налаштування доступності</span>
          </button>
        </div>
      </div>
      <div className="sg-app-footer-container">
        <div className="footer-info-text">
          <p>
            ТОВ «Споживчий центр» <br />
            ЄДРПОУ: 37356833 <br />
            Адреса: м. Київ, вул. Саксаганського, 33А <br />
            Ліцензія НБУ видана Нацкомфінпослуг, розпорядження від 28.02.2017 р.
            №438, яка
            <br />
            переоформлена 07.03.2024 р. Національним банком України на ліцензію
            на <br />
            діяльність фінансової компанії з правом надання послуги – надання
            коштів та
            <br />
            банківських металів у кредит. <br />
            <br />
            Тел: <a href="tel:0800504420">0800504420</a> <br />
            Email: <a href="mailto:info@sgroshi.com">info@sgroshi.com</a>
          </p>
        </div>

        <div className="footer-link-row">
          <div className="footer-link-item">
            <a
              href="https://www.instagram.com/sgroshicomua/"
              rel="nofollow noopener noreferrer"
            >
              <div className="footer-social-icon footer-social-inst"></div>
            </a>
          </div>
          <div className="footer-link-item">
            <a
              href="https://www.youtube.com/channel/UCdncfcYj9xakflSB1RUk-Zw"
              rel="nofollow noopener noreferrer"
            >
              <div className="footer-social-icon footer-social-yt"></div>
            </a>
          </div>
          <div className="footer-link-item">
            <a
              href="https://www.facebook.com/sgroshicomua"
              rel="nofollow noopener noreferrer"
            >
              <div className="footer-social-icon footer-social-fb"></div>
            </a>
          </div>
        </div>

        <p className="footer-sg-qoute">
          © {new Date().getFullYear()} ДовгоГроші
        </p>
      </div>
    </footer>
  );
}



// WEBPACK FOOTER //
// src/footer.js